import React from 'react';
import ExploreLayout from '../components/ExploreLayout';
import ExploreQuestion from '../components/ExploreQuestion';
import ExploreSuccess from '../components/ExploreSuccess';
import useExplore from '../hooks/useExplore';

const problemOptions = [
  { value: 'execution', icon: '✅', label: 'Staff forget tasks', description: 'Opening, cleaning, closing or compliance duties are missed.' },
  { value: 'visibility', icon: '👀', label: 'Managers find issues too late', description: 'Problems are only discovered after the damage is done.' },
  { value: 'stock', icon: '📦', label: 'Stock numbers are not trusted', description: 'Counts happen, but nobody knows where drift begins.' },
  { value: 'dispatch', icon: '🚚', label: 'Deliveries are hard to coordinate', description: 'Stores, drivers and stock do not operate from one live picture.' },
  { value: 'handover', icon: '🔁', label: 'Handover breaks down', description: 'The next shift does not inherit the same version of reality.' },
  { value: 'curious', icon: '✨', label: 'I want the full tour', description: 'Show how the three layers work together.' },
];

const industryOptions = [
  { value: 'restaurant', icon: '🍽️', label: 'Restaurant / Cafe', description: 'Duties, stock, shifts, deliveries and daily standards.' },
  { value: 'retail', icon: '🏪', label: 'Retail', description: 'Multi-site standards, stock accountability and dispatch.' },
  { value: 'warehouse', icon: '🏭', label: 'Warehouse', description: 'Teams, resources, handovers and coordination.' },
  { value: 'hotel', icon: '🏨', label: 'Hospitality', description: 'Housekeeping, departments, shifts and service standards.' },
  { value: 'security', icon: '🛡️', label: 'Security', description: 'Patrols, evidence, incidents and command visibility.' },
  { value: 'other', icon: '🧩', label: 'Other', description: 'Build a general operational journey.' },
];

export default function ExploreDiscoveryPage() {
  const { state, setAnswer } = useExplore();
  const answers = state.answers || {};
  const hasAnswers = answers.companyName || answers.industry || answers.problems?.length;

  return (
    <ExploreLayout
      stepId="discover"
      eyebrow="Operational Discovery"
      title="Let's build your operation."
      subtitle="Start by naming your company, then tell MatrixOS about your industry and biggest operational challenges. We'll personalise the experience around your business."
      nextLabel="Begin Neo mission"
    >
      <div className="explore-card" style={{ minHeight: 'auto', marginBottom: 16 }}>
        <label htmlFor="exploreCompanyName" style={{ display: 'block', fontWeight: 900, marginBottom: 8 }}>
          Your company name
        </label>
        <p style={{ margin: 0, color: 'var(--explore-muted)', lineHeight: 1.55 }}>
          This will be used later to make the public experience feel like your own operation.
        </p>
        <input
          id="exploreCompanyName"
          className="explore-input"
          type="text"
          placeholder="e.g. The Venue"
          value={answers.companyName || ''}
          onChange={(event) => setAnswer('companyName', event.target.value)}
        />
      </div>

      <ExploreQuestion questionKey="industry" title="What best describes your operation?" options={industryOptions} />
      <ExploreQuestion questionKey="problems" title="What keeps you awake at night?" options={problemOptions} multi />

      {hasAnswers && (
        <ExploreSuccess
          title="Explore profile created"
          description="These answers are stored only in this browser session. Refresh or close the browser and the public demo naturally resets."
        />
      )}
    </ExploreLayout>
  );
}
